import { getSPDataWithParams, postSPDataWithoutParams } from './services'

export const CASE_DISPATCH_API_ROOT = '/api/secure/cc/support/case-dispatch'
export const CASE_DISPATCH_ELIGIBILITY_PREVIEW_API = `${CASE_DISPATCH_API_ROOT}/eligibility/preview`
export const CASE_DISPATCH_REQUESTS_API = `${CASE_DISPATCH_API_ROOT}/requests`
export const CASE_DISPATCH_ELIGIBILITY_RESPONSE_KEY = 'case-dispatch-eligibility'
export const CASE_DISPATCH_REQUEST_RESPONSE_KEY = 'case-dispatch-request'
export const CASE_DISPATCH_POLICY_RESPONSE_KEY = 'case-dispatch-policy'
export const CASE_DISPATCH_OFFER_RESPONSE_KEY = 'case-dispatch-offer'

export function previewCaseDispatchEligibility(request = {}) {
  return postSPDataWithoutParams(CASE_DISPATCH_ELIGIBILITY_PREVIEW_API, request)
}

export function previewCaseDispatchEligibilityForBookedEvent(bookedEventId, options = {}) {
  return previewCaseDispatchEligibility({
    ...options,
    bookedEventId,
  })
}

export function previewCaseDispatchEligibilityForDraftDispatch(caseDispatchRequest, options = {}) {
  return previewCaseDispatchEligibility({
    ...options,
    caseDispatchRequest,
  })
}

export function createCaseDispatchRequest(request = {}) {
  return postSPDataWithoutParams(CASE_DISPATCH_REQUESTS_API, request)
}

export function createCaseDispatchRequestForBookedEvent(bookedEventId, options = {}) {
  return createCaseDispatchRequest({
    ...options,
    bookedEventId,
  })
}

export function createCaseDispatchRequestForDraftDispatch(caseDispatchRequest, options = {}) {
  return createCaseDispatchRequest({
    ...options,
    caseDispatchRequest,
  })
}

export function generateCaseDispatchDryRunOffers(requestId) {
  return postSPDataWithoutParams(`${CASE_DISPATCH_REQUESTS_API}/${requestId}/offers/dry-run`, {})
}

export function regenerateCaseDispatchDryRunOffers(requestId, request = {}) {
  return postSPDataWithoutParams(
    `${CASE_DISPATCH_REQUESTS_API}/${requestId}/offers/dry-run/regenerate`,
    request,
  )
}

export function dispatchCaseDispatchLive(requestId, request = {}) {
  return postSPDataWithoutParams(`${CASE_DISPATCH_REQUESTS_API}/${requestId}/dispatch/live`, request)
}

export function listCaseDispatchRequests(params = {}) {
  return getSPDataWithParams(CASE_DISPATCH_REQUESTS_API, params)
}

export function listCaseDispatchOffers(params = {}) {
  return getSPDataWithParams(`${CASE_DISPATCH_API_ROOT}/offers`, params)
}

export function getCaseDispatchRequest(requestId, options = {}) {
  return getSPDataWithParams(`${CASE_DISPATCH_REQUESTS_API}/${requestId}`, options)
}

export function listCaseDispatchOffersForRequest(requestId) {
  return getSPDataWithParams(`${CASE_DISPATCH_REQUESTS_API}/${requestId}/offers`, {})
}

export function cancelCaseDispatchRequest(requestId, request = {}) {
  return postSPDataWithoutParams(`${CASE_DISPATCH_REQUESTS_API}/${requestId}/cancel`, request)
}

export function expireCaseDispatchRequest(requestId, request = {}) {
  return postSPDataWithoutParams(`${CASE_DISPATCH_REQUESTS_API}/${requestId}/expire`, request)
}

export function extractCaseDispatchEligibility(response) {
  const payload = response?.data || response?.response?.data || response || {}
  return payload?.data?.[CASE_DISPATCH_ELIGIBILITY_RESPONSE_KEY] || null
}

export function extractCaseDispatchRequest(response) {
  const payload = response?.data || response?.response?.data || response || {}
  return payload?.data?.[CASE_DISPATCH_REQUEST_RESPONSE_KEY] || null
}

export function extractCaseDispatchPolicy(response) {
  const payload = response?.data || response?.response?.data || response || {}
  return payload?.data?.[CASE_DISPATCH_POLICY_RESPONSE_KEY] || null
}

export function extractCaseDispatchOffers(response) {
  const payload = response?.data || response?.response?.data || response || {}
  return payload?.data?.[CASE_DISPATCH_OFFER_RESPONSE_KEY] || []
}

export function extractCaseDispatchEligibilityErrorMessage(
  response,
  fallbackMessage = 'Case dispatch eligibility preview could not be completed',
) {
  const payload = response?.data || response?.response?.data || response || {}
  return payload?.message || fallbackMessage
}
